<div class="container bg-body-tertiary p-3" style="max-width: 1800px">
  <div class="row justify-content-between">
    <div class="col-12 col-lg-8">
      <app-card>
        <app-daily-info [last24HData]="last24HData"></app-daily-info>
      </app-card>
      <app-card>
        <app-insight-carrousel [insights]="insights"></app-insight-carrousel>
      </app-card>
      <app-card>
        <div
          class="d-flex justify-content-between flex-wrap gap-2 align-items-center mb-4"
        >
          <h3 class="m-0">
            {{ 'pages.cybersocxdr.home.incidentsAndAlertsPyramid' | translate }}
          </h3>
          <a class="link-chevron" routerLink="/xtended-soc/incidents">{{
            'pages.cybersocxdr.home.viewAllIncidents' | translate
          }}</a>
        </div>
        <div class="row">
          <app-scatterpyramid [data]="pyramidIncidentData"></app-scatterpyramid>
        </div>
      </app-card>
    </div>
    <div class="col-12 col-lg-4 mt-3 m-lg-0">
      <app-backlog-sanity-score
        [backlogStatus]="backlogStatus"
      ></app-backlog-sanity-score>
      <app-card class="mw-100">
        <app-4A3W-preview [actions]="actions"></app-4A3W-preview>
      </app-card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-card>
        <app-incident-needing-action-preview
          [incidents]="lastIncidentsNeedingActions"
        ></app-incident-needing-action-preview>
      </app-card>
    </div>
    <div class="col-12" *ngIf="incidentsRepartitionData">
      <app-card>
        <div class="row">
          <div
            class="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4"
          >
            <h3 class="m-0">
              {{
                'pages.cybersocxdr.home.handledIncidentsByCountry' | translate
              }}
            </h3>
            <a
              class="link-chevron"
              routerLink="/xtended-soc/dashboard/splitView"
              >{{ 'pages.cybersocxdr.home.accesToSplitView' | translate }}</a
            >
          </div>
        </div>
        <div class="row">
          <app-worldmap
            titleY="Handled Incidents"
            suffix="incidents"
            [data]="incidentsRepartitionData"
          ></app-worldmap>
        </div>
      </app-card>
    </div>
  </div>
</div>
